import { inject, Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import {
    DetailAttribute,
    PaginationData,
} from '../../../../shared/models/shared.model';
import { GroupApiCallService } from '../group-api-call.service';

@Injectable({ providedIn: 'root' })
export class EntityGroupService {
    private groupApiCallService = inject(GroupApiCallService);

    private entityGroupAttributes: DetailAttribute[] = [
        {
            label: 'Colors',
            name: 'colors',
            apiName: 'colorCode',
            type: 'select',
            placeholder: 'Select a color',
            control: [Validators.required],
        },
        {
            label: 'Entities',
            name: 'entityIds',
            apiName: 'entityIds',
            type: 'table',
            placeholder: 'Select a tenant first',
            control: [Validators.required],
            dependency: 'tenantId',
        },
    ];

    loadGroupAttributes(): DetailAttribute[] {
        return this.entityGroupAttributes;
    }

    loadEntityGroupTable(
        tenantId: number,
        pagination?: PaginationData,
    ): Observable<any> {
        return this.groupApiCallService.getDetailTableData(
            'EntityGroups',
            { name: 'tenants', parentId: tenantId },
            pagination,
        );
    }
}
